/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import DoctorTable from "components/tables/DoctorTable";
import useHttp from "hooks/http.hook";
import { FC, useEffect, useState } from "react";
import { ProviderInterface, QueryResultInterface } from "medicalsystem-shared";
import { useNavigate } from "react-router-dom";
import { CoreAPI_URLs } from "constants/http.const";
import Box from "components/generals/Box";
import Button from "components/generals/Button";
import { useTranslation } from "react-i18next";
import { RoutesConstants } from "medicalsystem-shared";
import PermissionWrapper from "components/generals/PermissionWrapper";
import { EntityPermissions, PermissionsUser } from "types";

/**
 * Component displaying paginated list of doctors with search and navigation.
 * Provides table view of doctor providers with options to create new doctor records.
 * 
 * @returns Doctor data content with table, pagination, and create button
 */
const DoctorsDataContent: FC = () => {
  const [isLoading, _error, sendRequest] = useHttp();
  const [doctorListResponse, setDoctorListResponse] = useState<ProviderInterface[]>([]);
  const [doctorFilter, setDoctorFilter] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);

  const navigate = useNavigate();

  const { t } = useTranslation();

  function handleNewDoctor() {
    navigate(RoutesConstants.NEW_DOCTOR);
  }

  useEffect(() => {
    const nameParam = doctorFilter ? `name=${doctorFilter}&` : "";
    const url = `${CoreAPI_URLs.DOCTOR_GET_ALL}?${nameParam}page=${page}&pageSize=${pageSize}`;

    sendRequest(url, onGetDoctorHandler, "GET");
  }, [doctorFilter, page, pageSize]);

  const onGetDoctorHandler = (doctorsResponse: QueryResultInterface<ProviderInterface>) => {
    setDoctorListResponse(doctorsResponse.results);
    setRowsTotal(doctorsResponse.total);
    setPageTotal(Math.ceil(doctorsResponse.total / pageSize));
  };

  return (
    <Box>
      <Box mt={2} mb={2} width="100%" display="flex" justifyContent="flex-end">
        <PermissionWrapper
          requiredPermissions={[PermissionsUser[EntityPermissions.DOCTORS].CREATE]}
        >
          <Button type="button" variant="contained" color="info" onClick={handleNewDoctor}>
            {t("doctorDataContent.newDoctor")}
          </Button>
        </PermissionWrapper>
      </Box>
      <DoctorTable
        modelList={doctorListResponse}
        setModelList={setDoctorListResponse}
        canSearchPlaceholder={t("doctorDataContent.searchDoctor")}
        setModelFilter={setDoctorFilter}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default DoctorsDataContent;
